import Alpine from "alpinejs"

type Direction = "next" | "previous"

type PhotoGallery = {
  slide: number
  count: number
  offsets: Array<number>
  animating: boolean
  show: (index: number) => void
  next: () => void
  previous: () => void
  goTo: (index: number, direction: Direction) => void
  isCurrent: (index: number) => boolean
  offsetFor: (index: number) => number
}

export function photoGallery(alpine: typeof Alpine) {
  alpine.data("photoGallery", function (count: number, start = 0): PhotoGallery {
    const size = Number(count)
    const total = Number.isFinite(size) && size > 0 ? Math.floor(size) : 0
    const from = Number(start)
    const first = total === 0 ? 0 : Math.min(Math.max(Number.isFinite(from) ? Math.floor(from) : 0, 0), total - 1)

    return {
      count: total,
      slide: first,
      animating: false,
      offsets: Array.from({ length: total }, (_, index) => (index === first ? 0 : 100)),

      show(index: number) {
        if (index < 0 || index >= this.count) return

        this.goTo(index, index < this.slide ? "previous" : "next")
      },

      next() {
        if (this.count === 0) return

        this.goTo((this.slide + 1) % this.count, "next")
      },

      previous() {
        if (this.count === 0) return

        this.goTo((this.slide - 1 + this.count) % this.count, "previous")
      },

      goTo(index: number, direction: Direction) {
        if (index === this.slide) return

        const entersFrom = direction === "next" ? 100 : -100

        this.animating = false
        this.offsets[index] = entersFrom

        this.$nextTick(() => {
          this.animating = true
          this.offsets[this.slide] = -entersFrom
          this.offsets[index] = 0
          this.slide = index
        })
      },

      isCurrent(index: number) {
        return this.slide === index
      },

      offsetFor(index: number) {
        return this.offsets[index] ?? 100
      },
    }
  })
}
